<template>
  <div class="input-wrapper">
    <label :for="name" v-if="label" class="label-input text-14 fw-500 text--left">{{label}}<span v-if="required" class="text-error text-14 fw-500">*</span></label>
    <div class="textarea-rd--state input-rd textarea-rd" :class="{ 'textarea__disabled': disabled, 'textarea__error': error }">
      <textarea :disabled="disabled" class="text-16 fw-300 textarea-rd--item" :placeholder="placeholder || 'Type here...' | translate" v-bind="$attrs" :id="name" :name="name" v-model="textareaVal" />
    </div>
    <span class="text-error text-14 fw-300" v-if="error">{{error | translate}}</span>
  </div>
</template>

<script>
export default {
  name: 'textarea-rd',
  props: ['label', 'disabled', 'name', 'error', 'placeholder', 'required', 'value'],
  computed: {
    textareaVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../less/redesign/base.less";

.textarea-rd--state {
  display: flex;
  &:focus-within {
    border: 1px solid @primary-blue;
  }
  &:hover {
    border: 1px solid @secondary-active;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.11);
  }
}
.textarea-rd {
  border-radius: 20px;
}

textarea.textarea-rd--item {
  &::placeholder {
    color: @grey-input;
  }
  outline: none;
  background: none;
  border: none;
  flex: 1;
  max-width: 100%;
  padding: 0;
  height: unset;
}

</style>



// WEBPACK FOOTER //
// src/ui/textarea/TextArea.vue